export default __webpack_public_path__ + "static/media/small-mod1.0abfeeb7.jpg";